import React from 'react';

import { Box } from '@chakra-ui/react';

import Typography from '../Typography';
import { SelectProps } from './Select.props';
import {
  Container,
  Error,
  ErrorContainer,
  SelectContainer,
  Select,
} from './Select.style';

const SelectView = ({
  options,
  placeholder = '- select -',
  disabled,
  error = '',
  errorProps,
  label,
  ...props
}: SelectProps): JSX.Element => {
  return (
    <Box>
      {label && (
        <Box mb={2}>
          <Typography variant="type9" color="shade5">
            {label}
          </Typography>
        </Box>
      )}
      <Container disabled={disabled}>
        <SelectContainer error={error}>
          <Select disabled={disabled} {...props}>
            <option key={placeholder} value="">
              {placeholder}
            </option>
            {options.map(({ value, label }) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </Select>
        </SelectContainer>
        <ErrorContainer>
          <Error color="special2" {...errorProps}>
            {error}
          </Error>
        </ErrorContainer>
      </Container>
    </Box>
  );
};

export default SelectView;
